import React from "react";
import type { FC } from "react";

import { Tag } from "../../../../Tag";
import { createDisplayNameForContentElement } from "../../utils/getDisplayName";
import { createTestIdForContentElement } from "../../utils/getTestId";

import type { OmitOfUnion } from "../../../../../types/react";
import type { TagProps } from "../../../../Tag";

const CONTENT_TAG_TEST_ID = createTestIdForContentElement("tag");

type ConstantTagProps = "size";

type ExtendedTagProps = TagProps & { label: string };

type ContentTagProps = OmitOfUnion<ExtendedTagProps, ConstantTagProps>;

export const ContentTag: FC<ContentTagProps> = (props) => {
    const { label, ...restProps } = props;

    return (
        <Tag {...(restProps as TagProps)} data-tsid={CONTENT_TAG_TEST_ID}>
            <Tag.Label>{label}</Tag.Label>
        </Tag>
    );
};

ContentTag.displayName = createDisplayNameForContentElement("Tag");

export default ContentTag;
